export const oneNumericalColumnShift = (inputData, xAxisField, yAxisField, dataField, columns) => { // shift table axis as described in this file: https://greenyellowbangkok.sharepoint.com/sites/it2/Shared%20Documents/Development/gymonitoring-react-docs/data-download/improve-data-download-page-table-axis-shift.drawio.png?Web=1
	// input data -> data from MySQL package
	// xAxisField -> key in input data
	// yAxisField => key in input data
	const groupedDataByYAxisField = [];
	let yAxisValues = [...new Set(inputData.map(row => row[yAxisField]))];
	let xAxisValues = [...new Set(inputData.map(row => row[xAxisField]))];

	yAxisValues.filter(val => !!val);
	yAxisValues.sort((a, b) => {
		if(typeof(a) === 'string' && typeof(b) === 'string') { return b.localeCompare(a) }
		if(typeof(a) === 'number' && typeof(b) === 'number') { return b - a }
		return 0;
	}); // DESC sorting
	yAxisValues.forEach(yAxisValue => {
		const rowsInYAxisValue = inputData.filter(row => row[yAxisField] === yAxisValue);
		groupedDataByYAxisField.push(rowsInYAxisValue);
	});
	
	// generate new rows
	const newData = [];
	groupedDataByYAxisField.forEach(group => {
		const newRow = { [yAxisField]: group[0][yAxisField] };
		group.forEach(row => {
			newRow[row[xAxisField]] = row[dataField];
		});
		newData.push(newRow);
	});

	// generate new columns
	let newColumns = xAxisValues.map(field => ({ title: field, field }));
	const xAxisColPretty = columns.find(col => col.value === yAxisField);
	newColumns = [{ title: xAxisColPretty.label, field: xAxisColPretty.value }, ...newColumns];

	// table name
	const dataColumnTitle = columns.find(col => col.value === dataField)?.label;

	return { newData, newColumns, dataColumnTitle };
}